import { translateWithFallback } from '@/i18n/translationUtils';

/**
 * Full label for the in-app notification "View" button.
 * Server notifications often use technical `event` keys (e.g. courses:expired);
 * those are mapped here. Human-readable events (e.g. "Action Point", scheduled event titles)
 * fall back to `View ${event}` in the component.
 */
export const NOTIFICATION_VIEW_BUTTON_BY_EVENT = {
    'team:invite-accepted': {
        key: 'notifications.viewActions.viewInvitation',
        fallback: 'View invitation',
    },

    'courses:assigned': {
        key: 'notifications.viewActions.viewCourse',
        fallback: 'View course',
    },
    'courses:expired': {
        key: 'notifications.viewActions.viewCourse',
        fallback: 'View course',
    },

    'audits:assigned': {
        key: 'notifications.viewActions.viewAudit',
        fallback: 'View audit',
    },
    'audit:uploaded': {
        key: 'notifications.viewActions.viewAudit',
        fallback: 'View audit',
    },

    'inventory:low-stock': {
        key: 'notifications.viewActions.viewInventory',
        fallback: 'View inventory',
    },
    'item:low-stock': {
        key: 'notifications.viewActions.viewInventory',
        fallback: 'View inventory',
    },

    'library:expired': {
        key: 'notifications.viewActions.viewDocument',
        fallback: 'View document',
    },
    'library:review-requested': {
        key: 'notifications.viewActions.reviewDocument',
        fallback: 'Review document',
    },
    'library:uploaded': {
        key: 'notifications.viewActions.viewDocument',
        fallback: 'View document',
    },

    'support:chat:created': {
        key: 'notifications.viewActions.openChat',
        fallback: 'Open chat',
    },
};

/**
 * @param {string | null | undefined} event
 * @param {Function | null | undefined} translateFn
 * @returns {string}
 */
export function getNotificationViewButtonLabel(event, translateFn = null) {
    if (!event || typeof event !== 'string') {
        return translateWithFallback(
            translateFn,
            'notifications.viewActions.viewDetails',
            'View details'
        );
    }
    if (
        Object.prototype.hasOwnProperty.call(
            NOTIFICATION_VIEW_BUTTON_BY_EVENT,
            event
        )
    ) {
        const label = NOTIFICATION_VIEW_BUTTON_BY_EVENT[event];
        return translateWithFallback(translateFn, label.key, label.fallback);
    }
    return translateWithFallback(
        translateFn,
        'notifications.viewActions.viewEvent',
        `View ${event}`,
        { event }
    );
}
